import { useMediaQuery } from "@react-hookz/web";

export function AdCard() {
  const _isMobileDevice = useMediaQuery("(max-device-width: 480px)");

  return (
    <a
      className="group relative z-10 mt-5 flex h-[200px] flex-col items-start justify-start overflow-hidden rounded"
      href="https://bikmo.com/uk/cycle-insurance/?utm_source=bikmo&utm_medium=theftmap&utm_campaign=cliktheft"
      rel="noopener noreferrer"
      target="_blank"
    >
      {/* <div className="h-full p-5">
        <Logo />
        <h1 className="mt-5 w-[14ch] font-sans text-2xl font-medium leading-6 text-white">
          Discover bike insurance you can trust
        </h1>
        <Button className="mt-5 !w-fit px-5" size="small">
          get {!isMobileDevice ? "a quote" : ""}
        </Button>
      </div> */}
      <img
        className="absolute left-0 z-[-1] h-[200px] w-full rounded border border-white/10 bg-center object-cover transition-all duration-200 group-hover:scale-105 group-hover:opacity-90"
        src="/assets/images/bikmo-ad.jpg"
        alt="Bikmo bike insurance"
      />
    </a>
  );
}
